interface createPodcastSrcProps {
  srcType: string;
  episodeNum?: string;
  embedUrl?: string;
}

export function createPodcastEmbedProps({
  srcType,
  episodeNum,
  embedUrl,
}: createPodcastSrcProps) {
  let src: string | undefined = undefined;
  let height = 90;

  if (srcType === "Libsyn" && episodeNum) {
    src = `https://html5-player.libsyn.com/embed/episode/id/${episodeNum}/height/90/width/864/theme/custom/autonext/no/thumbnail/yes/autoplay/no/preload/no/no_addthis/no/direction/forward/render-playlist/no/custom-color/afe6f1/`;
  }

  if (srcType === "Megaphone" && episodeNum) {
    src = "https://playlist.megaphone.fm?e=" + episodeNum;
    height = 205;
  }

  if (srcType === "Embed Url" && embedUrl) {
    src = embedUrl;
    height = embedUrl.includes("hbr-rss.streamguys1") ? 200 : 140;
  }

  return { src, height };
}
